module.exports = __webpack_public_path__ + "static/media/user_guide.bab63512.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/user_guide.svg
// module id = 1287
// module chunks = 1